//
//
//
//
//
//
//
//
//
//
//
//
//
//

import './iconfont/iconfont.css'
export default {
  data () {
    return {
      checked: true,
      down: 'down iconfont icon-paixujiantouxia app-pa',
      top: 'top iconfont icon-paixujiantoushang app-pa',
      state: 'default',
      flag: true
    }
  },
  props: {
    data: {
      default: () => []
    }
  },
  computed: {
    getLiStyle () {
      const len = this.data.length
      const width = 100 / len
      return `width: ${width}%;`
    }
  },
  watch: {
    state () {
      this.update()
    }
  },
  methods: {
    update () {
      this.flag = false
      this.$nextTick(function () {
        this.flag = true
      })
    },
    getTopStyle (item) {
      switch (item.sort) {
        case 'asc':
          item.sort = 'asc'
          return 'asc top iconfont icon-paixujiantoushang app-pa'
        case 'desc':
          item.sort = 'desc'
          return 'desc top down iconfont icon-paixujiantoushang app-pa'
        default:
          item.sort = 'default'
          return 'top iconfont icon-paixujiantoushang app-pa'
      }
    },
    getDownStyle (item) {
      switch (item.sort) {
        case 'asc':
          item.sort = 'asc'
          return 'asc down iconfont icon-paixujiantouxia app-pa'
        case 'desc':
          item.sort = 'desc'
          return 'desc down iconfont icon-paixujiantouxia app-pa'
        default:
          item.sort = 'default'
          return ' down iconfont icon-paixujiantouxia app-pa'
      }
    },
    toggleState (item) {
      switch (item.sort) {
        case 'asc':
          item.sort = 'desc'
          this.state = 'desc'
          this.down = 'desc down iconfont icon-paixujiantouxia app-pa'
          this.top = 'desc top iconfont icon-paixujiantoushang app-pa'
          break
        case 'desc':
          item.sort = 'default'
          this.state = 'default'
          this.down = 'down iconfont icon-paixujiantouxia app-pa'
          this.top = 'top iconfont icon-paixujiantoushang app-pa'
          break
        default:
          item.sort = 'asc'
          this.state = 'asc'
          this.down = 'asc down iconfont icon-paixujiantouxia app-pa'
          this.top = 'asc top iconfont icon-paixujiantoushang app-pa'
          break
      }
      item.change(item.sort)
      // console.log(this.data)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/simple/appSortList/App-sort-list.vue